import dayjs from 'dayjs';

export const SEARCH_PARAMETERS_API_IDS = {
  ORDER_ID: 'order_id_number',
  STATUS: 'status',
};

export const STATUS_API_IDS = {
  OPEN: 'open',
  CLOSED_BY_MERCHANT: 'closed_by_merchant',
  CLOSED_AUTO: 'closed_auto',
};

export const defaultParams = {
  [SEARCH_PARAMETERS_API_IDS.STATUS]: [STATUS_API_IDS.OPEN],
};

export function getConversationStatusColor(conversation) {
  const result = { light: true, color: '' };
  const responseNeededIn = conversation.response_needed_in;

  if (conversation.merchant_last_message_date) {
    result.color = 'default';
  } else if (responseNeededIn.late || !responseNeededIn.days) {
    result.color = 'error';
    if (responseNeededIn.late) {
      result.light = false;
    }
  } else if (responseNeededIn.hours <= 48) {
    result.color = 'warning';
  } else {
    result.color = 'warning';
    result.light = false;
  }
  return result;
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return dayjs(date).format('dddd D MMM HH:mm');
}

export function formatAuthorName(firstName, lastName) {
  if (!firstName && !lastName) return 'Inconnu';
  if (!lastName) return firstName;
  const initial = `${lastName.slice(0, 1).toUpperCase()}.`;
  return firstName ? `${firstName} ${initial}` : initial;
}

export function buildTimeline(messages, notes, closingEvents) {
  const items = [...messages.map((m) => ({ ...m, kind: 'message' })), ...(notes || []).map((n) => ({ ...n, kind: 'note' }))];
  if (closingEvents) {
    closingEvents.forEach((event) => {
      items.push({ kind: 'closed', created_on: event.date, ...event });
    });
  }
  items.sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
  return items;
}

export function formatConversationStatus(conversation, merchantLastMessageDate) {
  const responseNeededIn = conversation.response_needed_in;
  if (conversation.merchant_last_message_date) {
    const daysAfterLastMessage = dayjs().diff(merchantLastMessageDate, 'days');
    return `Il y a ${daysAfterLastMessage}j`;
  }
  if (responseNeededIn.late) {
    const overdue = responseNeededIn.days ? responseNeededIn.days : responseNeededIn.hours;
    const overdueUnit = responseNeededIn.days ? 'j' : 'h';
    return `Délai passé +${Math.abs(overdue)}${overdueUnit}`;
  }
  if (responseNeededIn.days > 1) {
    return `Échéance : ${responseNeededIn.days}j`;
  }
  if (responseNeededIn.days === 1) {
    const hours = responseNeededIn.hours + 24;
    return `Échéance : ${hours}h`;
  }
  return `Échéance : ${responseNeededIn.hours}h`;
}

export function formatShortDate(dateString) {
  const date = new Date(dateString);
  if (date.getFullYear() !== new Date().getFullYear()) {
    return dayjs(date).format('D MMM YYYY');
  }
  return dayjs(date).format('D MMM');
}

export function getMerchantLastMessageDate(conversation) {
  if (conversation.merchant_last_message_date) return conversation.merchant_last_message_date;
  if (!conversation.messages) return null;
  const merchantMessages = conversation.messages.filter((m) => m.type === 'merchant');
  if (merchantMessages.length === 0) return null;
  return merchantMessages[merchantMessages.length - 1].created_on;
}

export function getStatusLabel(conversation) {
  if (conversation.status.startsWith('closed')) return 'Discussion clôturée';
  const lastDate = getMerchantLastMessageDate(conversation);
  if (lastDate) {
    const days = dayjs().diff(dayjs(lastDate), 'days');
    return `Réponse envoyée il y a : ${days} jour${days > 1 ? 's' : ''}`;
  }
  if (conversation.response_needed_in) {
    return formatConversationStatus(conversation, dayjs());
  }
  return 'En attente de réponse';
}

export function getStatusTagColor() {
  return 'default';
}
